<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    active: true,
                  },
                ]"></vs-breadcrumb>
                    </div>
                </div>
                <!-- New Design starts -->
                <div class="row mt-2">
                    <!-- col-md-4 sub-programmes starts -->
                    <div class="col-md-4 mb-3">
                        <div class="trainings">
                            <div class="text-center crd-title">
                                <h5>TRAINING</h5>
                                <small>
                                    <b>({{ this.trainingFilterArr.length }} Trainings)</b>
                                </small>
                            </div>
                            <!-- sub-programmes list starts -->
                            <div class="mb-5">
                                <ul class="mt-4 list-ul pr-0 pl-0">
                                    <div class="p-2 mb-2">
                                        <input type="text" placeholder="Search ..." v-model="searchQueryTraining" class="search_button form-control form-control-sm" />
                                    </div>
                                    <!-- li starts -->

                                    <li v-for="(item, index) in strainingFilter" :key="item.training.id" :class="{ 'active-bg': active_tr == item.training.id }" class="display-li mb-2 pt-2 pb-2 hover-on-li" @click="
                        showTrainingDetail(item.training.id);
                        activateTr(item.training.id);
                      ">
                                        <div class="d-sm-flex justify-content-between" :key="index">
                                            <div class="d-sm-flex">
                                                <!--  <div class="short-title pr-3 align-self-center">
                            <b class="clr-blue" :key="index">{{item.training.training_code}}</b>
                          </div> -->
                                                <div class="md-title">
                                                    <h6>{{ item.training.title }}</h6>
                                                    <!-- <p>"Information Gathering & Analysis"</p> -->
                                                    <small v-if="
                                (item.training.startdate != null) &
                                  (item.training.enddate != null)
                              ">
                                                        {{ formatDate(item.training.startdate) }} -
                                                        {{ formatDate(item.training.enddate) }}
                                                    </small>
                                                    <small v-else>Start Date & End Date: Not defined yet.</small>
                                                    <p v-if="item.training.address != null">
                                                        {{ item.training.address }}
                                                    </p>
                                                    <p v-else>Address: Not defined yet.</p>
                                                </div>
                                            </div>
                                            <div class="align-self-center">
                                                <i class="material-icons large clr-orange" style>play_arrow</i>
                                            </div>
                                        </div>
                                    </li>
                                    <!-- li ends -->
                                </ul>
                            </div>
                            <!-- sub-programmes list ends -->
                        </div>
                    </div>
                    <!-- col-md-4 sub-programmes ends -->

                    <!-- col-md-4 projects starts -->
                    <div class="col-md-8 mb-3">
                        <div class="projects p-3 d-flex flex-column">
                            <div class="d-flex">
                                <div class="pr-3">
                                    <h6 class="underline-txt">SUB-PROGRAMME</h6>
                                    <small v-if="trainingDetail && trainingDetail.subprogram">
                                        <b>{{ trainingDetail.subprogram.title }}</b>
                                    </small>
                                    <p class="mt-2">
                                        Training Start Date: {{ formatDate(trainingDetail.startdate) }}
                                        <br />
                                        Training End Date: {{ formatDate(trainingDetail.enddate) }}
                                    </p>
                                    <h6 class="mt-3 underline-txt">Program Officer</h6>
                                    <small v-if="trainingDetail && trainingDetail.programofficer">
                                        <b>{{ trainingDetail.programofficer.name }}</b>
                                    </small>

                                </div>

                                <div class>
                                    <h6 class="underline-txt">PROJECT</h6>
                                    <small v-if="trainingDetail && trainingDetail.project">
                                        <b>{{ trainingDetail.project.title }}</b>
                                    </small>
                                    <p class="mt-2" v-if="trainingDetail && trainingDetail.project">
                                        Project Start Date: {{ formatDate(trainingDetail.project.startDate) }}
                                        <br />
                                        Project End Date: {{ formatDate(trainingDetail.project.endDate) }}
                                    </p>
                                    <h6 class="mt-3 underline-txt">Advisor</h6>
                                    <small v-if="trainingDetail && trainingDetail.advisor">
                                        <b>{{ trainingDetail.advisor.name }}</b>
                                    </small>
                                    <template v-if="trainingDetail.training_code != undefined ">
                                        <router-link v-bind:to="'/dashboard/Trainer/trainingAgenda?training='+trainingDetail.training_code" class="text-capitalize" style="float:right">Go to training wizard</router-link>
                                    </template>
                                </div>

                            </div>
                            <!-- projects list starts -->
                            <hr style="border-bottom:1px solid #333;opacity:0.5" />
                            <div class="d-flex">
                                <div class="row">
                                    <div class="col-sm-4 col-md-4">
                                        <div class="form-check">
                                            <b>PreAssesment</b>
                                            <br />
                                            <span class="text-success" v-if="trainingDetail.preassesment_status == 1">Enable</span>
                                            <span class="text-danger" v-else>Disable</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <div class="form-check">
                                            <b>PostAssesment</b>
                                            <br />
                                            <span class="text-success" v-if="trainingDetail.postassesment_status == 1">Enable</span>
                                            <span class="text-danger" v-else>Disable</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <div class="form-check">
                                            <b>Feedback</b>
                                            <br />
                                            <span class="text-success" v-if="trainingDetail.feedbackstatus == 1">Enable</span>
                                            <span class="text-danger" v-else>Disable</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr style="border-bottom:1px solid #333;opacity:0.5" />
                            <!--  <div class="mt-1">
                    <b-button
                      class="save-btn mt-1 btn-sm"
                      variant="primary"
                      @click="
                        showsingletrainingreport(trainingDetail.training_code)
                      "
                      >More Detail</b-button
                    >
                </div>-->
                            <!-- projects list ends -->
                            <div class="row mb-2 p-3">
                                <div class="col-sm-12 pl-0">
                                    <h6 class="pl-3">Agenda Title</h6>
                                </div>
                                <div class="col-sm-12">
                                    <vs-tabs v-if="newArr.length > 0">
                                        <vs-tab v-for="(day, index) in newArr" :key="index" :label="'Day ' + day.day">
                                            <div class="row p-1">
                                                <div class="table-responsive">
                                                    <table class="table table-borderless">
                                                        <thead>
                                                            <tr style="border-bottom:1px solid #333">
                                                                <th>Training Title</th>
                                                                <th>Assign Trainer</th>
                                                                <th>Title</th>
                                                                <th>Session</th>
                                                                <th>Start Time</th>
                                                                <th>End Time</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style="border-bottom:1px solid #333" v-for="(agenda, i) in day.data" :key="i">
                                                                <td style="width:30%">
                                                                    {{ trainingSingle.title }}
                                                                </td>
                                                                <td v-if="agenda.user">
                                                                    {{ agenda.user.name }}
                                                                </td>
                                                                <td v-else>N / A</td>
                                                                <td>{{ agenda.title }}</td>
                                                                <td>{{ agenda.session }}</td>
                                                                <td>{{ agenda.fromtime }}</td>
                                                                <td>{{ agenda.totime }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </vs-tab>
                                    </vs-tabs>
                                    <div v-else>Agenda Not found</div>
                                </div>
                                <hr style="border-bottom:1px solid #333;opacity:0.5" />
                            </div>
                        </div>
                    </div>
                    <!-- col-md-4 projects ends -->
                </div>
                <!-- New Design ends -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./main-sidebar";
import axios from "axios";
import {
    formatDate
} from "@/utils/DateFormate";

export default {
    data: () => ({
        trainerId: JSON.parse(localStorage.getItem("currentUser")).id,
        projectDiv: false,
        trainingDiv: false,
        isActve1: 1,
        trainingDialog: false,
        subprogramDialog: false,
        projectDialog: false,
        isSidebar: false,
        colorx: "warning",
        inValid: [],
        // sub program
        subprogramTitle: "",
        subprogramCode: "",
        searchQueryTraining: "",
        //Project
        subprogramArr: [],
        title: "",
        code: "",
        startDate: "",
        endDate: "",
        dateOptions: {
            dateFormat: "d-m-Y",
        },
        // training
        trainingtitle: "",
        trainingDetail: "",
        trainingFilterArr: [],
        active_tr: 0,
        agendasArray: [],
        newArr: [],
        trainingSingle: [],
    }),
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // this.showSubPrograms();
        this.showTrainings();
    },
    methods: {
        formatDate,
        activateTr: function activateTr(id) {
            this.active_tr = id;
        },

        showAssesments(traingId) {
            this.trainingSingle = [];
            this.newArr = [];
            this.agendasArray = [];
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/trainee/check/assesments/all/" +
                    traingId +
                    "/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();

                    this.trainingSingle = response.data.traininigSingle;
                    if (
                        response.data &&
                        response.data &&
                        response.data.checkPreAssesment != null &&
                        response.data.checkPostAssesment != null &&
                        response.data.checkFeedback != null
                    ) {
                        this.completeDiv = true;
                        this.IncompleteDiv = false;
                    } else {
                        this.preAssessment = response.data.checkPreAssesment;
                        this.postAssessment = response.data.checkPostAssesment;
                        this.feedbackstatus = response.data.checkFeedback;
                        this.IncompleteDiv = true;
                        this.completeDiv = false;
                    }
                    if (
                        response.data &&
                        response.data.agenda &&
                        response.data.agenda.length > 0
                    ) {
                        this.agendasArray = response.data.agenda;
                        this.agendasArray.forEach((val) => {
                            if (this.newArr.some((person) => person.day === val.days)) {
                                this.dayIndex = this.newArr.map((e) => e.day).indexOf(val.days);
                                this.newArr[this.dayIndex].data.push(val);
                            } else {
                                this.newArr.push({
                                    day: val.days,
                                    data: [val],
                                });
                            }
                        });
                    }
                    //this.activatePr(response.data[0].id);
                    //this.activateTr(response.data[0].id);
                });
        },

        showsingletrainingreport(code) {
            this.$router.push({
                path: "/dashboard/Trainer/trainerDashboard",
                query: {
                    training: code
                },
            });
        },
        // this will show trainings of the single trainer
        showTrainings() {
            this.trainingFilterArr = [];
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/trainer/trainings/clear/" +
                    this.trainerId +
                    "/filter"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingFilterArr = response.data;
                    if (
                        response.data[0] &&
                        response.data[0].training &&
                        response.data[0].training.id
                    ) {
                        this.activateTr(response.data[0].training.id);
                        this.showTrainingDetail(response.data[0].training.id);
                    }
                });
        },
        // this will show projects of the subprogram
        showTrainingDetail(id) {
            this.trainingDetail = "";
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/trainer/training/detail/" +
                    id +
                    "/filter"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingDetail = response.data;
                    this.showAssesments(id);
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true,
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
            });
        },
    },
    computed: {
        strainingFilter: function () {
            return this.trainingFilterArr.filter((items) => {
                if (
                    String(items.training.title).toLowerCase().indexOf(this.searchQueryTraining.toLowerCase()) !==
                    -1
                ) {
                    return true;
                }

                return false;
            });
        },
    },
};
</script>

<style scoped>
.modal-btn {
    padding: 0px 50px;
    height: 30px;
    border-radius: 10px;
}

#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.active {
    background: #dff0d8 !important;
    /* color:#fff !important; */
}

.margin_bottom_admin {
    margin-bottom: 30px;
}

.active.training-title-cards {
    color: #fff !important;
}

ul.date-ul {
    display: inline-flex;
}

ul li {
    cursor: pointer;
}

a {
    cursor: pointer;
}

.date-ul li.start-date {
    padding-right: 35px;
}

.cards-row {
    margin-top: 10px !important;
}

.card-col {
    padding: 5px !important;
}

.main-card {
    color: #6c757d;
    border: 1px dotted #07a7e14f;
}

.main-card:hover {
    border: 1px solid #07a7e14f;
}

.training-title {
    /* font-size: 15px; */
    font-weight: 500;
    /* color: #212529 !important; */
}

.training-title-cards {
    font-size: 15px;
    font-weight: 500;
    /* color: #212529; */
}

.con-vs-card.withHover:hover img {
    -webkit-transform: scale(1);
    transform: scale(1);
}

.cardheader {
    display: inline-flex;
}

@media (max-width: 768px) {
    .card-col {
        width: 100% !important;
    }

    ul.date-ul {
        margin-top: 5px;
    }

    .date-ul li.start-date {
        padding-right: 26px;
    }

    .training-title {
        font-size: 14px;
    }
}

@media (max-width: 991.98px) {

    /* ul.date-ul {
    margin-top: -16px;
    display: block;
  } */
    .date-ul li.start-date {
        padding-right: 26px;
    }

    .card-col {
        width: 100% !important;
    }

    ul.date-ul {
        margin-top: 5px;
    }
}

.p-0 {
    padding: 0px;
}

.p-t-0 {
    padding-top: 0px;
}

.p-b-0 {
    padding-bottom: 0px;
}

.p-l-0 {
    padding-left: 0px;
}

.p-r-0 {
    padding-right: 0px;
}

.m-0 {
    margin: 0px;
}

.m-t-0 {
    margin-top: 0px;
}

.m-b-0 {
    margin-bottom: 0px;
}

.m-l-0 {
    margin-left: 0px;
}

.m-r-0 {
    margin-right: 0px;
}

.p-5 {
    padding: 5px;
}

.p-t-5 {
    padding-top: 5px;
}

.p-b-5 {
    padding-bottom: 5px;
}

.p-l-5 {
    padding-left: 5px;
}

.p-r-5 {
    padding-right: 5px;
}

.m-5 {
    margin: 5px;
}

.m-t-5 {
    margin-top: 5px;
}

.m-b-5 {
    margin-bottom: 5px;
}

.m-l-5 {
    margin-left: 5px;
}

.m-r-5 {
    margin-right: 5px;
}

.p-10 {
    padding: 10px;
}

.p-t-10 {
    padding-top: 10px;
}

.p-b-10 {
    padding-bottom: 10px;
}

.p-l-10 {
    padding-left: 10px;
}

.p-r-10 {
    padding-right: 10px;
}

.m-10 {
    margin: 10px;
}

.m-t-10 {
    margin-top: 10px;
}

.m-b-10 {
    margin-bottom: 10px;
}

.m-l-10 {
    margin-left: 10px;
}

.m-r-10 {
    margin-right: 10px;
}

.p-15 {
    padding: 15px;
}

.p-t-15 {
    padding-top: 15px;
}

.p-b-15 {
    padding-bottom: 15px;
}

.p-l-15 {
    padding-left: 15px;
}

.p-r-15 {
    padding-right: 15px;
}

.m-15 {
    margin: 15px;
}

.m-t-15 {
    margin-top: 15px;
}

.m-b-15 {
    margin-bottom: 15px;
}

.m-l-15 {
    margin-left: 15px;
}

.m-r-15 {
    margin-right: 15px;
}

.p-20 {
    padding: 20px;
}

.p-t-20 {
    padding-top: 20px;
}

.p-b-20 {
    padding-bottom: 20px;
}

.p-l-20 {
    padding-left: 20px;
}

.p-r-20 {
    padding-right: 20px;
}

.m-20 {
    margin: 20px;
}

.m-t-20 {
    margin-top: 20px;
}

.m-b-20 {
    margin-bottom: 20px;
}

.m-l-20 {
    margin-left: 20px;
}

.m-r-20 {
    margin-right: 20px;
}

.p-25 {
    padding: 25px;
}

.p-t-25 {
    padding-top: 25px;
}

.p-b-25 {
    padding-bottom: 25px;
}

.p-l-25 {
    padding-left: 25px;
}

.p-r-25 {
    padding-right: 25px;
}

.m-25 {
    margin: 25px;
}

.m-t-25 {
    margin-top: 25px;
}

.m-b-25 {
    margin-bottom: 25px;
}

.m-l-25 {
    margin-left: 25px;
}

.m-r-25 {
    margin-right: 25px;
}

.p-30 {
    padding: 30px;
}

.p-t-30 {
    padding-top: 30px;
}

.p-b-30 {
    padding-bottom: 30px;
}

.p-l-30 {
    padding-left: 30px;
}

.p-r-30 {
    padding-right: 30px;
}

.m-30 {
    margin: 30px;
}

.m-t-30 {
    margin-top: 30px;
}

.m-b-30 {
    margin-bottom: 30px;
}

.m-l-30 {
    margin-left: 30px;
}

.m-r-30 {
    margin-right: 30px;
}

.p-35 {
    padding: 35px;
}

.p-t-35 {
    padding-top: 35px;
}

.p-b-35 {
    padding-bottom: 35px;
}

.p-l-35 {
    padding-left: 35px;
}

.p-r-35 {
    padding-right: 35px;
}

.m-35 {
    margin: 35px;
}

.m-t-35 {
    margin-top: 35px;
}

.m-b-35 {
    margin-bottom: 35px;
}

.m-l-35 {
    margin-left: 35px;
}

.m-r-35 {
    margin-right: 35px;
}

.p-40 {
    padding: 40px;
}

.p-t-40 {
    padding-top: 40px;
}

.p-b-40 {
    padding-bottom: 40px;
}

.p-l-40 {
    padding-left: 40px;
}

.p-r-40 {
    padding-right: 40px;
}

.m-40 {
    margin: 40px;
}

.m-t-40 {
    margin-top: 40px;
}

.m-b-40 {
    margin-bottom: 40px;
}

.m-l-40 {
    margin-left: 40px;
}

.m-r-40 {
    margin-right: 40px;
}

.p-45 {
    padding: 45px;
}

.p-t-45 {
    padding-top: 45px;
}

.p-b-45 {
    padding-bottom: 45px;
}

.p-l-45 {
    padding-left: 45px;
}

.p-r-45 {
    padding-right: 45px;
}

.m-45 {
    margin: 45px;
}

.m-t-45 {
    margin-top: 45px;
}

.m-b-45 {
    margin-bottom: 45px;
}

.m-l-45 {
    margin-left: 45px;
}

.m-r-45 {
    margin-right: 45px;
}

.p-50 {
    padding: 50px;
}

.p-t-50 {
    padding-top: 50px;
}

.p-b-50 {
    padding-bottom: 50px;
}

.p-l-50 {
    padding-left: 50px;
}

.p-r-50 {
    padding-right: 50px;
}

.m-50 {
    margin: 50px;
}

.m-t-50 {
    margin-top: 50px;
}

.m-b-50 {
    margin-bottom: 50px;
}

.m-l-50 {
    margin-left: 50px;
}

.m-r-50 {
    margin-right: 50px;
}

.v-b {
    vertical-align: bottom;
}

.card .card-header {
    background-color: transparent;
    border-bottom: none;
    padding: 20px;
    position: relative;
}

.latest-update-card .card-block {
    padding-top: 0;
}

.latest-update-card .card-block .latest-update-box {
    position: relative;
}

.latest-update-card .card-block .latest-update-box:after {
    content: "";
    position: absolute;
    background: #ebebeb;
    height: 100%;
    width: 3px;
    top: 0;
    left: 19px;
    z-index: 1;
}

.latest-update-card .card-block .latest-update-box .update-meta {
    z-index: 2;
}

.latest-update-card .card-block .latest-update-box .update-meta .update-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    padding: 7px 8px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #fff;
}

.latest-update-card .card-block .update-icon.bg-c-red {
    -webkit-box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
    box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-blue {
    -webkit-box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
    box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-green {
    -webkit-box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
    box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-yellow {
    -webkit-box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
    box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
}

.latest-update-card .card-block .update-icon.ring {
    border-width: 3px;
    width: 15px;
    height: 15px;
    padding: 0;
    display: block;
    margin-left: 13px;
    background: #fff;
}

.latest-update-card .card-block .latest-update-box .update-meta i.update-icon {
    margin-left: 4px;
    margin-right: 19px;
}

.latest-update-card .card-block .update-icon {
    padding: 0;
    width: 40px;
    height: 40px;
}

.bg-c-lite-blue {
    background: -webkit-gradient(linear-gradient(to right, #06a6e0, #00d2d6));
    background: linear-gradient(to right, #06a6e0, #00d2d6);
}

.bg-c-lite-purple {
    background: -webkit-gradient(linear-gradient(to right, #955cf9, #96a5f9));
    background: linear-gradient(to right, #955cf9, #96a5f9);
}

.bg-c-lite-pink {
    background: -webkit-gradient(linear-gradient(to right, #fe5d70, #fe909d));
    background: linear-gradient(to right, #fe5d70, #fe909d);
}

@media only screen and (max-width: 575px) {
    .latest-update-card .card-block .latest-update-box:after {
        display: none;
    }

    .latest-update-card .card-block .latest-update-box .update-meta {
        z-index: 2;
        min-width: 100%;
        text-align: left !important;
        margin-bottom: 15px;
        border-top: 1px solid #f1f1f1;
        padding-top: 15px;
    }
}

.sub-programmes {
    background-color: #fff2e5;
    border: 2px solid #ffdfbb;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
}

.projects {
    background-color: #f9ffe6;
    border: 2px solid #d4e891;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
}

.trainings {
    background-color: #e6f4ff;
    border: 2px solid #9fdcf7;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
}

.crd-title {
    margin-top: 10px;
}

.crd-title h5 {
    text-transform: uppercase;
}

.crd-title small b {
    font-size: 14px;
    text-transform: capitalize;
}

.clr-orange {
    color: #ef8100;
}

.clr-green {
    color: #a4c639;
}

.clr-blue {
    color: #00a4ea;
}

b {
    color: #080808;
    font-size: 13px;
}

.add-new {
    position: absolute;
    width: 90%;
    bottom: 2px;
}

.bg-clr-orange {
    background-color: #fff2e5;
    padding: 10px;
}

.bg-clr-green {
    background-color: #f9ffe6;
    padding: 10px;
}

.bg-clr-blue {
    background-color: #e6f4ff;
    padding: 10px;
}

.add-new h6 {
    color: #080808;
    font-size: 15px;
}

.list-ul {
    padding: 5px;
}

.short-title {
    padding: 8px 4px 8px 12px;
}

.md-title {
    padding: 0px 4px;
}
</style><style>
.modal-dialog {
    background: transparent !important;
}

.modal-dialog input {
    border-radius: 5px !important;
    height: 32px !important;
}

#bv-modal-example___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

#bv-modal-example2___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

#bv-modal-example3___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

.active-bg {
    background: #eedfd1 !important;
}

.hover-on-li:hover {
    background: #eedfd1 !important;
}
</style><style>
.not-full {
    padding: 4px 4px !important;
}

.underline-txt {
    text-decoration: underline;
}
</style>
